import { useOperationsStore } from '@tom-ui/operations'
import { GateClerkHomePage, NavigationStack, OutboundOrderValidationDto } from '@tom-ui/planning'
import {
  allocationsService,
  containerTurnoverService,
  generalCargoStockService,
  OutboundRequestValidationControl,
} from '@tom-ui/storage'
import { useRoutingSlipMiniMap, useYardStores } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

export const GateClerkPage = observer(() => {
  const { yardBlockStore } = useYardStores()
  const { gangStore } = useOperationsStore()

  const { loadStores, renderRouteMiniMap } = useRoutingSlipMiniMap()

  useEffect(() => {
    loadStores()
  }, [loadStores])

  const getJourneyPositions = async (
    journeyIds: number[],
    isForPlannedPosition?: boolean,
  ): Promise<{ journeyId: number; position: string }[]> => {
    const positions = await yardBlockStore.getBlockNamesByJourneyIds(
      journeyIds,
      isForPlannedPosition,
    )

    return positions.map(({ journeyId, position }: { journeyId: number; position: string }) => {
      return {
        journeyId,
        position: position ?? '',
      }
    })
  }

  const renderOutboundValidation = (params: OutboundOrderValidationDto) => (
    <OutboundRequestValidationControl
      isOutbound={params.isOutbound}
      customerId={params.customerId}
      commodityId={params.commodityId}
      lotNumber={params.lotNumber}
      packageId={params.packageId}
      quantity={params.quantity}
      unitIds={params.unitIds}
      imoClasses={params.imoClasses}
      hideSuccessfulValidation
    />
  )

  return (
    <NavigationStack>
      <GateClerkHomePage
        getJourneyPositions={getJourneyPositions}
        validateAllocationCapacity={allocationsService.validateAllocationCapacity}
        getEasiestContainerToReach={(containerIds?: number[], amount?: number) =>
          containerTurnoverService.getEasiestContainerToReach(containerIds, amount)
        }
        getGeneralCargoReservations={orderId =>
          generalCargoStockService.getPlannedOccupanciesByOrderId(orderId)
        }
        renderOutboundValidation={renderOutboundValidation}
        renderRouteMiniMap={renderRouteMiniMap}
        gangs={gangStore.items}
        onFetchGangs={() => gangStore.fetchData()}
      />
    </NavigationStack>
  )
})
